import { EnvironmentProviders, computed, inject, makeEnvironmentProviders } from '@angular/core';
import { AccountRef, SIDEBAR_SITES, SidebarSite, VISIBLE_ACCOUNTS } from '../../core/navigation';
import { SitesApi } from './sites.api';

const MAX_SIDEBAR_SITES = 5;

/**
 * Collega i cantieri alla struttura comune: la sezione "Cantieri" della barra laterale (i
 * cantieri attivi più recenti, al massimo cinque) e gli account visibili per il percorso.
 */
export function provideSitesNavigation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SIDEBAR_SITES,
      useFactory: () => {
        const api = inject(SitesApi);
        return computed<readonly SidebarSite[]>(() =>
          api.all.hasValue()
            ? api.all
                .value()
                .sites.filter((site) => site.status === 'active')
                .slice(0, MAX_SIDEBAR_SITES)
                .map((site) => ({ id: site.id, name: site.name, link: `/sites/${site.id}` }))
            : [],
        );
      },
    },
    {
      provide: VISIBLE_ACCOUNTS,
      useFactory: () => {
        const api = inject(SitesApi);
        return computed<readonly AccountRef[]>(() =>
          api.all.hasValue()
            ? api.all.value().accounts.map((account) => ({ id: account.id, name: account.name }))
            : [],
        );
      },
    },
  ]);
}
